import { writable } from 'svelte/store'
import { api } from '@fno/service/global.js'
import createCache from '@fno/lib/create-cache.js'

export const tabTool = writable(null)
export const appImplementation = writable(null)

// const clientOnboardingCache = createCache()
const appImplementationCache = createCache()
const tabToolCache = createCache()

export const getTabTool = async ({ schoolId }) => tabToolCache(
    () => api
        .get(`/v2/tasks?filter.subTypes=TAB_TOOL&filter.schoolIds=${schoolId}`)
        .then(response => response.data[0])
        .then(data => {
            tabTool.set(data)
            return data
        })
)

export const getAppImplementation = async ({ schoolId }) => appImplementationCache(
    () => api
        .get(`/v2/tasks?filter.subTypes=APP_IMPLEMENTATION&filter.schoolIds=${schoolId}`)
        .then(response => response.data[0])
        .then(data => {
            appImplementation.set(data)
            return data
        })
)

export const patchTask = async ({ task }) => api
    .patch(`/v2/tasks/${task.id}`, { data: task })
    .then(response => response.data)
    .then(data => {
        if (data.attributes.subType === 'TAB_TOOL') {
            tabTool.set(data) // Ensure a new reference is set
        } else if (data.attributes.subType === 'APP_IMPLEMENTATION') {
            appImplementation.set(data)
        }
        return data
    })

export const finalizeTabTool = async ({ schoolId, organizationId }) => api
    .post('/v2/tasks', {
        data: {
            type: 'TASK',
            attributes: {
                organizationId,
                subType: 'FINALIZE_TAB_TOOL'
            },
            meta: {
                schoolId
            }
        }
    })
